import SpeechToSpeechView from "./SpeechToSpeech.view";
function SpeechToSpeechContainer(props) {
    return <SpeechToSpeechView />;
}

export default SpeechToSpeechContainer;
